module.exports = __webpack_public_path__ + "static/media/ja-JP.e0dde3f2.md";